import { message } from 'antd';
import css from './CustomizeModal.module.scss';
import Close from './icons/Close';
import { useGlobal } from '@/utils/useGlobal';

export default function CustomizeModal({ app, callback }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const [title, setTitle] = useState(app?.title);
    const [isEdit, setIsEdit] = useState(false);
    const [watt, setWatt] = useState(app?.watt || '');
    const [hours, setHours] = useState(app?.hours || '');
    const WATT_MAX = 7200;

    const handleInputPower = (e: any) => {
        if (e.target.value.length > 4) {
            return;
        }
        setWatt(e.target.value);
    };

    const handleInputHours = (e: any) => {
        if (e.target.value.length > 4) {
            return;
        }
        setHours(e.target.value);
    };

    const handleInputTitle = (e: any) => {
        setTitle(e.target.value);
    };

    const handleCancel = () => {
        callback(null);
    };

    const handleConfirm = () => {
        const powerRegex = /^\d{1,4}$/;
        const timeRegex = /^\d+(\.\d{0,1})?$/;
        if (Number(watt) > WATT_MAX) {
            return message.warning({ className: 'dpu-calculator-msg', content: t('step2_A_input_max') });
        }
        if (!powerRegex.test(watt) || !Number(watt) || !timeRegex.test(hours) || hours > 24 || !Number(hours) || Number(watt) <= 0 || Number(hours) <= 0) {
            return message.error({ className: 'dpu-calculator-msg', content: t('step2_A_input_error') });
        }
        const newApp = {
            ...app,
            power: Number(watt) * Number(hours),
            desc: `${watt}${t('step2_A_power_w')}/${hours} ${t('step2_A_customize_h')}/${t('step2_A_customize_d')}`,
            watt: Number(watt),
            selected: 1,
            title,
            hours: Number(hours),
        };
        callback(newApp);
    };

    return (
        <div className={`customize-modal ${css['customize-modal']}`}>
            <div className="modal-content">
                <div className="modal-header">
                    {!isEdit && (
                        <div className="title-box">
                            <span className="title">{title}</span>
                            <span className="edit" onClick={() => setIsEdit(true)}>
                                {t('step2_A_edit')}
                            </span>
                        </div>
                    )}
                    {isEdit && (
                        <input type="text" className="edit-title" value={title} onChange={handleInputTitle} autoFocus={true} onBlur={() => setIsEdit(false)} />
                    )}
                    <span className="close" onClick={handleCancel}>
                        <Close />
                    </span>
                </div>
                <div className="modal-body">
                    <div className="power-box box">
                        <p className="title">{t('step2_A_power_rating')}</p>
                        <div className="input-box">
                            <input type="text" className="input" value={watt} onChange={handleInputPower} />
                            <span className="unit">{t('step2_A_power_w')}</span>
                        </div>
                        <p className="tip">{t('step2_A_power_tip')}</p>
                    </div>
                    <div className="time-box box">
                        <p className="title">{t('step2_A_time_daily')}</p>
                        <div className="input-box">
                            <input type="text" className="input" value={hours} onChange={handleInputHours} />
                            <span className="unit">{t('step2_A_time_h')}</span>
                        </div>
                        <p className="tip">{t('step2_A_time_tip')}</p>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="cancel" onClick={handleCancel}>
                        {t('step2_A_cancel')}
                    </button>
                    <button className="confirm" onClick={handleConfirm}>
                        {t('step2_A_confirm')}
                    </button>
                </div>
            </div>
            <style jsx global>
                {`
                    .announcement-bar {
                        z-index: 100;
                    }
                    .ecoflow-frame-header {
                        z-index: 150 !important;
                    }
                    .festival-float {
                        z-index: 180;
                    }
                    .dpu-calculator-msg {
                        .ant-message-notice-content {
                            padding: 10px 50px;
                            border-radius: 8px;
                            width: max-content;
                            margin: 0 auto;
                            max-width: calc(100vw - 48px);
                            .ant-message-custom-content {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                gap: 10px;
                                .anticon {
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 0;
                                    svg {
                                        width: 100%;
                                        height: 100%;
                                    }
                                    & + span {
                                        font-family: var(--ff-woff2-M);
                                        font-size: 16px;
                                        line-height: 1.2;
                                        color: #000;
                                    }
                                }
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
